// Vendor JS
import Debug from 'debug';

// Custom JS
import cigAPI from '../util/cig-api';
import Cig from "../util/Cig";

/* eslint-disable class-methods-use-this */

class ForgotPassword {
	constructor() {
		try {
			this.init();
		} catch (err) {
			Debug(`cig:error:sage:class:ForgotPassword`)(`constructor Error: %s %o`, err.message, err);
			throw new Error(err);
		}
	}

	/**
	 * Initialize the ForgotPassword class by adding event handler(s)
	 */
	init = () => {
		try {
			this.addForgotPasswordHandler();
		} catch (err) {
			Debug(`cig:error:sage:class:ForgotPassword`)(`init Error: %s %o`, err.message, err);
			throw new Error(err);
		}
	}

	/**
	 * Show the response message on the DOM and remove any previous messages
	 *
	 * @param message {string} Message to print above the email field
	 * @param successful {boolean} The status of the request determines which CSS class to add to the message
	 * @param email {string} The email for the account
	 */
	showForgotPasswordResponse = (message, successful, email) => {
		try {
			const loginContainerInnerDiv = document.querySelector('.login-form-container').querySelector('div');
			const previousMessages = loginContainerInnerDiv.querySelectorAll('.forgot-password-api-message');
			const successClass = successful ? ' success' : '';

			// For 200 response always show the same message
			if (successful) {
				message = `Password reset instructions sent to ${email}`;
				// For anything else show the message received if one exists; otherwise show this
			} else if (typeof message !== 'string') {
				message = 'An error occurred, please try again or <a href="/contact/">contact support</a>';
			}

			// Loop through and hide all previous messages
			Array.from(previousMessages).forEach(element => {
				element.style.display = 'none';
			});

			const loginHeaderElement = document.getElementById('login-form-feedback');
			loginHeaderElement.innerHTML = `<h6 class="forgot-password-api-message${successClass}">${message}</h6>`;

		} catch (err) {
			Debug(`cig:error:sage:class:ForgotPassword`)(`showForgotPasswordResponse Error: %s %o`, err.message, err);
			throw new Error(err);
		}
	}

	/**
	 * When a user clicks on forgot password verify there is an email in the input and then send data to CIGAPI
	 *
	 * @param event {object} The event that triggered the handler
	 */
	forgotPasswordHandler = async event => {
		try {
			event.preventDefault();
			event.target.disabled = true;

			const email = (document.getElementById('txtEmail').value).toLowerCase();
			const placeholder = (document.getElementById('txtEmail').getAttribute('placeholder')).toLowerCase();
			let successful = false;

			// If email isn't null, empty, the same as the placeholder, or an invalid format
			if (email && (email !== "") && (email !== placeholder) && Cig.isValidEmailAddress(email)) {
				const response = await cigAPI(`login`, `reset-password`, { email });
				successful = response.status === 200;

				// Show the user some feedback if it was successful or not
				this.showForgotPasswordResponse(response.data && response.data.message, successful, email);
			}
			else {
				this.showForgotPasswordResponse('Please enter the account email and try again', successful, email);
			}
		} catch (err) {
			// We don't want to stop execution if this fails so catch the error and do NOT re-throw
			Debug(`cig:error:sage:class:ForgotPassword`)(`forgotPasswordHandler Error: %s %o`, err.message, err);

			// Show failure message
			this.showForgotPasswordResponse(err.data && err.data.message, false, email);
		}
	}

	/**
	 * Add event listener and callback to forgot password
	 */
	addForgotPasswordHandler = () => {
		try {
			const forgotPasswordButton = document.getElementById('forgot-password');

			if (forgotPasswordButton) {
				forgotPasswordButton.addEventListener('click', this.forgotPasswordHandler, false);
			}

		} catch (err) {
			Debug(`cig:error:sage:class:ForgotPassword`)(`addForgotPasswordHandler Error: %s %o`, err.message, err);
			throw new Error(err);
		}
	}
}

export default ForgotPassword;
